function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import * as React from "react";
var SvgRedIcon = function SvgRedIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M31.5854 9.22973C33.0673 9.22973 34.2686 8.02847 34.2686 6.54663C34.2686 5.06479 33.0673 3.86353 31.5854 3.86353C30.1036 3.86353 28.9023 5.06479 28.9023 6.54663C28.9023 8.02847 30.1036 9.22973 31.5854 9.22973Z",
    fill: "#F41240"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6127 8.93311L4.75586 8.93311L4.75586 29.8956H10.0043V23.0757H20.0613L24.6498 29.8956H30.5268L25.4669 23.0442C27.0383 22.7928 28.1697 22.1957 28.8611 21.2529C29.5526 20.3101 29.8983 18.8015 29.8983 16.7901V15.2187C29.8983 14.0244 29.7725 13.0816 29.5526 12.3587C29.3325 11.6359 28.9554 11.0073 28.4211 10.4416C27.8554 9.90737 27.2269 9.53022 26.4726 9.27882C25.7183 9.05877 24.7755 8.93311 23.6127 8.93311ZM22.7641 18.4557H10.0043V13.553H22.7641C23.4869 13.553 23.9898 13.6787 24.2412 13.8988C24.4926 14.1187 24.6498 14.5273 24.6498 15.1244V16.8844C24.6498 17.5129 24.4926 17.9215 24.2412 18.1415C23.9898 18.3615 23.4869 18.4557 22.7641 18.4557Z",
    fill: "white"
  }));
};
export default SvgRedIcon;